import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Pendencia } from 'src/app/models/pendencia';
import { PendenciaPedido } from 'src/app/models/pendenciapedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PendenciaService } from 'src/app/services/pendencia.service';

@Component({
  selector: 'app-lista-pendencia-modal',
  templateUrl: './lista-pendencia-modal.component.html',
  styleUrls: ['./lista-pendencia-modal.component.scss']
})
export class ListaPendenciaModalComponent implements OnInit {

  pendenciasDoPedido: PendenciaPedido[];
  idCupom: string;
  pendencias: Pendencia[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<ListaPendenciaModalComponent>,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private pendenciaService: PendenciaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data) {
      this.idCupom = this.data.idCupom;
    }
  }

  async ngOnInit() {
    await this.buscarPendenciasPedido();
  }

  async buscarPendenciasPedido() {
    try {
      this.carregandoService.mostra('buscarPendenciasPedido');
      this.pendenciasDoPedido = await this.pendenciaService.consultarPorIdCupom(this.idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPendenciasPedido');
    }
  }

  fechar() {
    this.dialogRef.close();
  }

}
